import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import RelatedServices from '../RelatedServices'
import MakeupGallery from './MakeupGallery'
import { cld } from '../../../utils/cld'

const NAILS_IMAGES = [
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920667/237FDBF4-99C9-47D3-911E-89678EF9516C_v275ik.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920667/BAF0C474-6FD9-49FE-BB94-01DB34AE35F6_cicgov.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920669/F905B4C1-E0D8-4CCD-9898-53A3E42FAF14_i9gmho.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920667/6C60B36C-D414-449A-891C-2A433438DA66_klbf0a.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920668/IMG_4591_ajduep.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920668/IMG_2683_kb0qhb.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920669/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_qa39lf.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920687/IMG_4593_zop4ac.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920688/IMG_4595_xi4wk2.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920689/IMG_4599_hftnyo.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920733/IMG_4602_dmrols.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920733/IMG_4603_acqjgn.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920734/IMG_4605_1_yqgomn.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920734/IMG_4604_idhzft.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920737/IMG_4608_ydcknl.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920738/IMG_4611_et8nzx.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779920738/3A178A88-C5AA-4402-B4AF-048ECA90298E_xwa08m.jpg",
]

const Img27    = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1757965882/27_xwk8g9.jpg"
const ImgMom   = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315014/IMG_0721_qmihap.jpg"
const ImgNails = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315014/IMG_0720_vnrm8t.jpg"

const callBtnStyle = {
  display: "inline-block",
  padding: "15px 35px",
  backgroundColor: "#90510F",
  color: "#ffffffff",
  fontWeight: "600",
  fontSize: "1.2rem",
  borderRadius: "8px",
  textDecoration: "none",
  border: "1px solid #ddd",
  transition: "transform 0.3s",
}

const Main = () => {
  const { t } = useTranslation()

  const sidebarLinks = [
    { to: "/makeup",           label: t('servicesSidebar.makeup'),          active: false },
    { to: "/permanent-makeup", label: t('servicesSidebar.permanentMakeup'), active: false },
    { to: "/vega",             label: t('servicesSidebar.vega'),            active: false },
    { to: "/baby-lips",        label: t('servicesSidebar.babyLips'),        active: false },
    { to: "/eyelashes",        label: t('servicesSidebar.eyelashes'),       active: false },
    { to: "/nails",            label: t('servicesSidebar.nails'),           active: true  },
    { to: "/depilation",       label: t('servicesSidebar.depilation'),      active: false },
    { to: "/hairdresser",      label: t('servicesSidebar.hairdresser'),     active: false },
  ]

  const ContactBox = () => (
    <div className="service-detail-contact wow fadeup-animation" data-wow-delay="1.1s">
      <h3 className="h3-title">{t('servicesSidebar.contactTitle')}</h3>
      <a
        href="tel:0653585545"
        style={callBtnStyle}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {t('servicesSidebar.callNow')}
      </a>
    </div>
  )

  return (
    <>
      <Bredcrumb title={t('nailsService.breadcrumbTitle')} subtitle={t('nailsService.breadcrumbSubtitle')} />

      <div className="about-area5 about-p p-relative">
        <div className="container pt-120 pb-90">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-4 order-1">
              <aside className="sidebar services-sidebar">
                <div className="sidebar-widget categories">
                  <div className="widget-content">
                    <ul className="services-categories">
                      {sidebarLinks.map(({ to, label, active }) => (
                        <li key={to} className={active ? 'active' : ''}>
                          <Link to={to}>{label} <i className="fa fa-arrow-right"></i></Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="d-none d-lg-block">
                  <ContactBox />
                </div>
              </aside>
            </div>
            <div className="col-lg-8 col-md-12 col-sm-12 order-2">
              <div className="service-detail">
                <div className="content-box">
                  <MakeupGallery images={NAILS_IMAGES} ariaLabel="nails" altPrefix="Manicure & Pedicure" />
                  <h2>{t('nailsService.h2')}</h2>
                  <p>{t('nailsService.p1')}</p>
                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(Img27, { w: 900 })} alt="Manikir i pedikir - Vision Beauty Niš" width="900" height="600" loading="lazy" decoding="async" /></figure>
                      </div>
                      <div className="text-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgMom, { w: 900 })} alt="Estetski pedikir - Vision Beauty Niš" width="900" height="600" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>

                  <h3>{t('nailsService.manicureTitle')}</h3>
                  <p>{t('nailsService.manicureP')}</p>

                  <h3>{t('nailsService.pedicureTitle')}</h3>
                  <p>{t('nailsService.pedicureP')}</p>

                  <h3>{t('nailsService.differenceTitle')}</h3>
                  <ul>
                    {t('nailsService.differenceItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('nailsService.gelTitle')}</h3>
                  <p>{t('nailsService.gelP')}</p>

                  <h3>{t('nailsService.gelNaturalTitle')}</h3>
                  <p>{t('nailsService.gelNaturalP1')}</p>
                  <p>{t('nailsService.gelNaturalP2')}</p>
                  <p>{t('nailsService.gelNaturalP3')}</p>

                  <h3>{t('nailsService.gelPolishTitle')}</h3>
                  <p>{t('nailsService.gelPolishP')}</p>
                  <ul>
                    {t('nailsService.gelPolishItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('nailsService.summaryTitle')}</h3>
                  <ul>
                    {t('nailsService.summaryItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-12 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgNails, { w: 1200 })} alt="Nadogradnja i gel lak na noktima - Vision Beauty Niš" width="1170" height="762" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RelatedServices items={[{ to: "/depilation", labelKey: "servicesSidebar.depilation" }, { to: "/eyelashes", labelKey: "servicesSidebar.eyelashes" }]} />
          <div className="row d-lg-none">
            <div className="col-12">
              <ContactBox />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Main
